export default function installVueEntities(NetteAjax) {
  let enabled = false
  const $entities = {}

  const jsonParse = (json) => {
    return JSON.parse(json, (key, value/*, ctx*/) => {
      if (typeof value === 'string' && value.substring(0, 3) === '$e:') {
        const [, entityType, entityId] = value.split(':')
        if (typeof $entities[entityType] === 'undefined') {
          $entities[entityType] = {}
        }

        if (typeof $entities[entityType][entityId] === 'undefined') {
          $entities[entityType][entityId] = {}
        }

        return $entities[entityType][entityId]

      } else if (key === '$entities') {
        Object.keys(value).forEach((entityType) => {
          Object.keys(value[entityType]).forEach((entityId) => {
            Object.keys(value[entityType][entityId]).forEach((entityValueKey) => {
              $entities[entityType][entityId][entityValueKey] = value[entityType][entityId][entityValueKey]
            })
          })
        })

        return undefined
      }
      
      return value
    })
  }

  if (typeof window?.netteInitialState === 'string' || window?.netteInitialState instanceof String) {
    enabled = true
    console.log('using vue entities parser', JSON.parse(window.netteInitialState))
    window.netteInitialState = jsonParse(window.netteInitialState)
  }
  
  return NetteAjax.ext('vue-entities', {
    success: function (payload/*, response, settings*/) {
      if (!enabled || !payload.json) {
        return
      }

      const parsedJson = jsonParse(payload.json)
      Object.keys(parsedJson).forEach((key) => {
        payload[key] = parsedJson[key]
      })
    }
  }, {
    enabled,
    $entities,
    jsonParse
  })
}
